import React from "react";
import StarRating from "./StarRating";
import { ProductCardAction } from "./ProductCardAction";
import { Countdown } from "./CountDown";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { AddTocartButton } from "./AddTocartButton";
import { useSelector } from "react-redux";
import { formatSoldCount } from "../service";


export default function ProductCard({ product, isCountDown = false,className,onClick }) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  
  return (
    <div className={`w-full xl:p-4 flex flex-col justify-between bg-white group/card ${className}`}>
      <div className="relative border rounded-xl shadow-sm overflow-hidden">
        <Link to={`/products/${product?._id}?ref=${userInfo?.address??""}`} className=" relative  "  onClick={onClick} >
          <img
            src={product?.image?.["url"]}
            alt={product?.name}
            className="w-full h-auto  object-contain"
          />
          <img
            src={product?.arrImage?.[1]?.["url"] ? product?.arrImage?.[1]?.["url"] : product?.image?.["url"]}
            alt={product?.name}
            className="w-full h-auto object-contain absolute top-0 left-0 z-40 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300"
          />
          {product?.discount > 0 && (
            <span className="absolute top-2 left-2 bg-red-500 text-white text-[10px] px-[5px] py-[1px] rounded z-50">
              Sale
            </span>
          )}
          {/* {isCountDown && <Countdown endDate={"2025-09-12T23:59:59"} />} */}

        </Link>
        <ProductCardAction product={product}  />
      </div>
      <div className="mt-3 flex flex-col gap-1 items-start">
        <Link to={`/products/${product?._id}?ref=${userInfo?.address??""}`}  onClick={onClick} > <h3 className="text-sm font-semibold line-clamp-2 text-left hover:text-[--color-button-3] transition-all duration-150  ">{product?.name}</h3> </Link>
        <div className="flex items-center gap-2">
          <StarRating rate={product?.rating ?? 0} />
          <span className="text-xs text-gray-400 ">({product?.numReviews ?? 0})</span>
        </div>


        <div className="flex items-center gap-2 flex-wrap justify-between w-full">
          <span className="flex w-1/3 xl:w-auto text-sm xl:text-base font-bold text-red-600 gap-2">
             <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.price?.toFixed(2)}
          </span>
          {product?.oldPrice && <span className="flex  w-1/3 xl:w-auto text-sm line-through text-gray-400  gap-2">
             <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.oldPrice?.toFixed(2)}
          </span>}
          {product?.discount && <span className="flex justify-center  xl:w-auto bg-green-600 text-white text-xs px-[5px] py-[1px] rounded-md">
            {product?.discount}%
          </span>}
          <span className="okkk3rd">Đã bán {formatSoldCount(product?.sold)}</span>
        </div>
      </div>

      <AddTocartButton product={product} />
    </div>
  );
}
